/* 🤖 this file was generated by script */
export const wsolidiconTrash04 = {
  name: 'trash_04',
  data: `<svg viewBox="0 0 24 24"><path fill="currentColor" d="M8 3a1 1 0 0 1 1-1h6a1 1 0 1 1 0 2H9a1 1 0 0 1-1-1"/><path fill="currentColor" fill-rule="evenodd" d="M2 6a1 1 0 0 1 1-1h18a1 1 0 1 1 0 2h-1.06l-.65 9.63q-.06 1.13-.16 1.88c-.08.53-.2 1.02-.46 1.47a4 4 0 0 1-1.73 1.62c-.47.23-.96.32-1.5.36q-.75.05-1.9.04h-3.09q-1.13.01-1.9-.04a4 4 0 0 1-1.49-.36 4 4 0 0 1-1.73-1.62 4 4 0 0 1-.46-1.47q-.1-.75-.16-1.88L4.06 7H3a1 1 0 0 1-1-1" clip-rule="evenodd"/></svg>`,
  iconStyle: 'solid',
};
